import { createActions } from 'redux-actions';

export default createActions(
  {
    RESET: () => ({}),
    INIT: (robotId) => ({ robotId }),
    SET: (robotId, key, data) => ({ robotId, key, data }),
    REMOVE: (robotId) => ({ robotId }),
  },
  { prefix: 'TELEMETRY' }
);
